if (!customElements.get('fj-purchase-status')) customElements.define('fj-purchase-status', class extends HTMLElement {
  connectedCallback() {
    this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
    if (!this.root) return;
    this.variants = JSON.parse(this.querySelector('script').textContent);
    this.bar = this.querySelector('[data-fj-sticky]');
    this.stickyButton = this.querySelector('[data-fj-sticky-button]');
    this.refresh = () => {
      const form = this.root.querySelector('product-form form');
      const button = form?.querySelector('[name="add"]');
      const span = button?.querySelector('span');
      const variant = this.variants.find(v => String(v.id) === form?.querySelector('[name="id"]')?.value);
      if (!variant || !span) return;
      if (!button.classList.contains('loading')) {
        let label;
        if (button.disabled && !variant.available && variant.has_stock) label = this.dataset.deliveryLabel;
        else if (!button.disabled && this.dataset.preorder === 'true') label = this.dataset.preorderLabel;
        if (label && span.textContent.trim() !== label) span.textContent = label;
      }
      if (this.stickyButton) {
        this.stickyButton.disabled = button.disabled || button.classList.contains('loading');
        this.stickyButton.textContent = span.textContent.trim();
        const price = this.root.querySelector('[id^="price-"] .price-item--regular');
        if (price) this.querySelector('[data-fj-sticky-price]').textContent = price.textContent.trim();
      }
    };
    this.observer = new MutationObserver(this.refresh);
    this.observer.observe(this.root, {subtree:true,childList:true,attributes:true,attributeFilter:['value','disabled','class']});
    this.root.addEventListener('change', this.refresh);
    this.refresh();
    const buyButton = this.root.querySelector('product-form [name="add"]');
    if (this.bar && buyButton) {
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      });
      this.visibilityObserver.observe(buyButton);
    }
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.visibilityObserver?.disconnect();
    this.root?.removeEventListener('change', this.refresh);
  }
});
